/**
 * Integrations as listed in the Geofleet app's integrations catalogue. `status` mirrors the app:
 * available = can be configured today, integrated = connected by default, soon = on the roadmap.
 * `logo` is a Simple Icons slug served from /images/brands/<slug>.svg (CC0 marks, self-hosted); brands without one show initials.
 */
export type IntegrationStatus = 'available' | 'integrated' | 'soon';
export type IntegrationBrand = { name: string; status: IntegrationStatus; logo?: string; initials?: string };
export type IntegrationCategory = { key: string; icon: string; color: string; brands: IntegrationBrand[] };

const a = (name: string, logo?: string, initials?: string): IntegrationBrand => ({ name, status: 'available', logo, initials });
const i = (name: string, logo?: string, initials?: string): IntegrationBrand => ({ name, status: 'integrated', logo, initials });
const s = (name: string, logo?: string, initials?: string): IntegrationBrand => ({ name, status: 'soon', logo, initials });

export const INTEGRATION_CATEGORIES_LEFT: IntegrationCategory[] = [
  {
    key: 'commerce',
    icon: 'ri-shopping-cart-2-line',
    color: '#7C3AED',
    brands: [
      a('Shopify', 'shopify'),
      i('Google Sheets', 'googlesheets'),
      s('WooCommerce', 'woocommerce'),
      s('BigCommerce', 'bigcommerce'),
      s('Adobe Commerce', undefined, 'Mg'),
      s('Dynamics 365', undefined, 'D365'),
      s('UniCommerce', undefined, 'UC'),
      s('ClickPost', undefined, 'CP'),
      s('EasyEcom', undefined, 'EE'),
    ],
  },
  {
    key: 'erp',
    icon: 'ri-database-2-line',
    color: '#475569',
    brands: [
      i('Acumatica', undefined, 'ACU'),
      s('SAP', 'sap'),
      s('QuickBooks', 'quickbooks'),
      s('Xero', 'xero'),
      s('Zoho Books', 'zoho'),
      s('HubSpot', 'hubspot'),
      s('Salesforce', undefined, 'SF'),
    ],
  },
  {
    key: 'automation',
    icon: 'ri-flow-chart',
    color: '#0EA5E9',
    brands: [
      s('Zapier', 'zapier'),
      s('Make', 'make'),
      s('n8n', 'n8n'),
      s('OpenAI', undefined, 'AI'),
      s('Anthropic', 'anthropic'),
      s('Google Gemini', 'googlegemini'),
      s('Azure OpenAI', undefined, 'Az'),
      s('DeepSeek', 'deepseek'),
    ],
  },
];

export const INTEGRATION_CATEGORIES_RIGHT: IntegrationCategory[] = [
  {
    key: 'messaging',
    icon: 'ri-chat-3-line',
    color: '#16A34A',
    brands: [
      a('Twilio', undefined, 'TW'),
      a('Vonage', 'vonage'),
      a('Infobip', undefined, 'IB'),
      a('M360', undefined, 'M360'),
      a('Etisalat (e&)', undefined, 'ETI'),
      a('SendGrid', undefined, 'SG'),
      i('AWS SES', undefined, 'SES'),
      s('MSG91', undefined, '91'),
      s('Gupshup', undefined, 'GS'),
      s('Mailgun', 'mailgun'),
    ],
  },
  {
    key: 'payments',
    icon: 'ri-bank-card-line',
    color: '#DB2777',
    brands: [
      s('Stripe', 'stripe'),
      s('Razorpay', 'razorpay'),
      s('PayPal', 'paypal'),
      s('PayU', undefined, 'PU'),
      s('WhatsApp Business', 'whatsapp'),
      s('Slack', undefined, 'SL'),
      s('Microsoft Teams', undefined, 'MS'),
      s('Telegram', 'telegram'),
    ],
  },
  {
    key: 'maps',
    icon: 'ri-truck-line',
    color: '#F97316',
    brands: [
      i('Google Maps', 'googlemaps'),
      a('Ola Maps', undefined, 'OLA'),
      a('HERE Maps', 'here'),
      s('Mapbox', 'mapbox'),
      s('TomTom', 'tomtom'),
      s('DHL Express', 'dhl'),
      s('FedEx', 'fedex'),
      s('UPS', 'ups'),
      s('Aramex', undefined, 'AR'),
      s('Porter', undefined, 'PR'),
      s('Shipa', undefined, 'SH'),
    ],
  },
];
